module.exports = "/work-site/img/logo.be0a9a8e.png";